export default __webpack_public_path__ + "static/media/flyosea.766d4288.png";